import { HISTORY } from 'constants/api'
import useAxios from 'axios-hooks'
import { useSession } from 'contexts/session-context'
import { useEffect } from 'react'
import LoadingScreen from 'components/loading-screen'
import { Crown, DivStateAccount, LiStateAccount, PStateAccount } from 'theme/profile'

function History() {
  const [{ data: session }] = useSession()
  const [{ data, loading, error }, refetch] = useAxios({
    url: HISTORY,
    headers: { Authorization: `Bearer ${((session as any)?._tokenResponse as any)?.idToken}` }
  })

  useEffect(() => {
    refetch()
  }, [])

  if (error) {
    return (
      <div className="flex-1 m-7 flex justify-center items-center">
        <h1 className="text-2xl font-bold">Ha ocurrido un error</h1>
      </div>
    )
  }

  return loading ? (
    <LoadingScreen />
  ) : (
    <div>
      {data.length ? (
        <ul>
          {data.map((item: any) => {
            return (
              <LiStateAccount key={item.exchangeAt} className="relative border-b-2">
                <DivStateAccount className="h-16 flex items-center px-10"></DivStateAccount>
                <div className="h-28"></div>
                <div className="absolute top-0 grid" style={{ gridTemplateColumns: '176px 1fr' }}>
                  <div className="flex justify-center items-center h-full" style={{ height: 176 }}>
                    {!item?.imageUrl && (
                      <Crown
                        className="w-28 h-28 flex justify-center items-center"
                        style={{ backgroundSize: 'contain' }}
                      >
                        <p className="text-4xl font-bold">{item.pointsEarned}</p>
                      </Crown>
                    )}
                    {item?.imageUrl && (
                      <img
                        src={item?.imageUrl}
                        alt={`Foto del premio ${item.title}`}
                        style={{ height: 'auto', width: 'auto', maxHeight: 124, maxWidth: 124 }}
                      />
                    )}
                  </div>
                  <div className="grid" style={{ gridTemplateRows: '64px 112px' }}>
                    <div className="flex items-center">
                      <PStateAccount className={`font-bold ${item.title.length > 30 ? 'text-xl' : 'text-2xl'}`}>{item.title}</PStateAccount>
                    </div>
                    <div className="py-2 text-left">
                      {item.costInPoints && item.costInPoints !== '0' && (
                        <p className="din font-bold text-sm">
                          {item.costInPoints} {POINTS_NAME}
                        </p>
                      )}
                      {item.triviaCostInPoints && item.triviaCostInPoints !== '0' && (
                        <p className="din font-bold text-sm">
                          {item.triviaCostInPoints} {POINTS_NAME} USADAS
                        </p>
                      )}
                      {item.pointsEarned && item.pointsEarned !== '0' && (
                        <p className="din font-bold text-sm">
                          {item.pointsEarned} {POINTS_NAME} ADQUIRIDAS
                        </p>
                      )}
                      {item.triviaTitle && item.triviaTitle !== '0' && (
                        <p className="text-sm">TRIVIA: {item.triviaTitle}</p>
                      )}
                      <p className="text-sm">
                        Adquirido el{' '}
                        {new Date(item.exchangeAt).toLocaleString('es-MX', {
                          day: '2-digit',
                          month: '2-digit',
                          year: '2-digit'
                        })}
                      </p>
                    </div>
                  </div>
                </div>
              </LiStateAccount>
            )
          })}
        </ul>
      ) : (
        <h1 className="text-2xl font-bold text-center mt-20">
          No has canjeado ningún premio aún<br></br>
          <br></br>
          ¡Venga, tú puedes!
        </h1>
      )}
    </div>
  )
}

export default History
